<template>
  <dialog-template
    :openDialog="isOpen"
    :widthDialog="'1000px'"
    :appendToBody="true"
    :modalAppendToBody="true"
    :classDialog="'dialog-bhanh-doc-out'"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <div class="padding-bottom-10">
        <h3 class="dialogTitle">{{ dialogTitle }}</h3>

        <div class="select-Unit-BanHanh">
          <!-- department-tree -->
          <div class="content">
            <el-row :gutter="18">
              <el-col :span="12" class="fix__top">
                <el-input
                  class="style-fullWidth searchBox"
                  v-model="search"
                  size="medium"
                  placeholder="Nhập tên đơn vị để tìm kiếm"
                  prefix-icon="el-icon-search"
                  @keydown.enter.exact.native="searchTree"
                ></el-input>
              </el-col>
            </el-row>

            <VuePerfectScrollbar
              class="scroll-scope listCompanies"
              :settings="settings"
            >
              <el-tree
                class="filter-tree"
                :data="departmentTree"
                default-expand-all
                ref="departmentTree"
                :filter-node-method="filterDepartmentTreeNode"
              >
                <span
                  class="custom-tree-node tree_unit between"
                  slot-scope="{ node, data }"
                >
                  <span v-if="data.nodeType == DEPARTMENT_TREE.NODE_TYPE.DEPT">
                    <el-checkbox
                      @click.native.stop="() => true"
                      @change="nodeCheckedChange(data)"
                      v-model="data.checked"
                    ></el-checkbox>
                    <span
                      >&nbsp;{{
                        data.department
                          ? buildDepartmentLabel(data.department)
                          : null
                      }}</span
                    >
                  </span>

                  <span
                    v-else-if="
                      [
                        DEPARTMENT_TREE.NODE_TYPE.DVTT,
                        DEPARTMENT_TREE.NODE_TYPE.PBCN,
                      ].indexOf(data.nodeType) != -1
                    "
                  >
                    <span
                      >&nbsp;{{
                        data.nodeType == DEPARTMENT_TREE.NODE_TYPE.DVTT
                          ? "Đơn vị trực thuộc"
                          : "Phòng ban chức năng"
                      }}</span
                    >
                  </span>
                </span>
              </el-tree>
            </VuePerfectScrollbar>
          </div>
          <!-- department-tree:end -->
        </div>
      </div>
    </template>
    <template #footer>
      <div class="flex-row flex__left form-button__action">
        <el-button class="dialogBtnPrimary btn-none__border" @click="banHanh">
          Chọn&nbsp;<i class="fas fa-arrow-circle-right font-size__small"></i>
        </el-button>
      </div>
    </template>
  </dialog-template>
</template>

<script>
import constants from "../../constants";
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import displayDepartmentTreeMixin from "../../mixins/displayDepartmentTreeMixin";

export default {
  name: "commonSelectDepartmentDialog",
  mixins: [displayDepartmentTreeMixin],
  props: ["isOpen", "multipleSelect", "title"],
  components: {
    dialogTemplate: () => import("../common/custom-dialog.vue"),
    VuePerfectScrollbar,
  },

  data() {
    return {
      settings: { maxScrollbarLength: 750 },
      search: null,
      checkedNodes: [],
      DEPARTMENT_TREE: constants.DEPARTMENT_TREE,
      DEPARTMENT: constants.DEPARTMENT,
    };
  },

  created() {
    this.loadDepartments();
  },

  computed: {
    dialogTitle() {
      return this.title ? this.title : "Nơi nhận bên trong";
    },
  },

  methods: {
    banHanh() {
      let event = {
        selectedDepartments: this.checkedNodes.map(node => node.department),
      };

      this.$emit("change", event);
      this.$emit("closeDialog");
    },

    searchTree() {
      this.$refs.departmentTree.filter(this.search);
    },

    nodeCheckedChange(data) {
      if (data.checked) {
        if (!this.checkedNodes.includes(data)) {
          this.checkedNodes.push(data);
        }
      } else {
        const index = this.checkedNodes.indexOf(data);
        if (index > -1) {
          this.checkedNodes.splice(index, 1);
        }
      }
    }
  },
};
</script>

<style scoped>
.select-Unit-BanHanh .content {
  padding: 10px 15px;
  border: 1px solid #ceced2;
  border-radius: 4px;
}

.select-Unit-BanHanh .label {
  color: #2d3e4f;
  font-size: 12px;
  line-height: 20px;
  margin-bottom: 10px;
  margin-top: 7px;
}

.select-Unit-BanHanh .content .listCompanies.scroll-scope {
  margin-top: 5px;
  position: relative;
  width: 100%;
}

.select-Unit-BanHanh .content .listCompanies .company_item {
  margin: 10px 0;
}

.select-Unit-BanHanh .content .listCompanies .company_item .name {
  color: #2d3e4f;
  font-weight: 700;
}

.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-right: 25px;
}

.tag_select {
  box-shadow: 0px 0.5px 1.5px rgb(0, 0, 0, 0.05);
  transition: all 0.25s;
}

.tag_select:hover {
  transform: translateY(2px);
  text-decoration: underline;
  transition: 0.15s;
  box-shadow: none;
}

.searchBox {
}
</style>



// WEBPACK FOOTER //
// src/views/common/commonSelectDepartmentDialog.vue